<template>
  <b-container class="mw-100 mt-3">
    <b-card class="mt-4 mb-4">
      <standard-table ref="notTransmittingObuTable"
                      search-id="log-search"
                      :items="items"
                      :fields="fields"
                      :search-place-holder="`${$tc('message.example', 1)}: FL149BR`"
                      :row-before-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                      :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                      :row-after-search="{cols: 12, sm: 12, md: 12, lg: 4, xl: 4, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                      :after-search="{cols: 12, sm: 12, md: 12, lg: 12, xl: 12}"

                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                      :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                      :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"
                      fullWidth="true"
                      noContainerPadding="true"
      >

        <b-container slot="row-after-search" class="mw-100 p-0 ">
          <b-row>
            <b-col cols="auto">
              <b-button v-on:click="resetFilters()" class="b-c-green" id="reset-filters">
                {{ $t('message.resetFilters') }}
              </b-button>
            </b-col>

            <b-col cols="auto" class="mb-3">
              <b-button @click="showCollapse = !showCollapse" :class="showCollapse ? 'b-c-red' : 'b-c-green'">
                <span v-show="!showCollapse" class="when-opened">
                  {{ $t('message.show') }} {{ $tc('message.filter', 2).toLowerCase() }}
                </span>
                <span v-show="showCollapse" class="when-closed">
                  {{ $t('message.hide') }} {{ $tc('message.filter', 2).toLowerCase() }}
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container slot="after-search" class="mw-100 p-0">
          <b-collapse id="my-collapse" v-model="showCollapse">
            <b-container class="mw-100 m-0 p-0">
              <b-row>
                <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.lastTransmissionDate', 1)}`"
                                label-for="input-associated-vehicle">
                    <model-list-select id="input-associated-vehicle"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="associatedVehicleOptions && associatedVehicleOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="associatedDateFilter"
                                       :list="associatedVehicleOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.transmittingLabel', 1)}`"
                                label-for="input-time">
                    <model-list-select id="input-time"
                                       option-text="text"
                                       :is-disabled="!showTimeFilter"
                                       option-value="value"
                                       :placeholder="timeOptions && timeOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="timeFilter"
                                       :list="timeOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>
                <b-col v-if="showTimeFilter && showPersonalizedDate" cols="12" sm="12" md="6" lg="4" xl="3">
                  <b-form-group :label="$tc('message.from', 1)"
                                label-for="start">
                    <b-input-group>
                      <flat-pickr id="start"
                                  :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                  class="form-control"
                                  :readonly="false"
                                  v-model="personalizedDate"
                                  :config="startDateConfig">
                      </flat-pickr>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.associatedVehicle', 1)}`"
                                label-for="input-associated-vehicle">
                    <model-list-select id="input-associated-vehicle"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="associatedVehicleOptions && associatedVehicleOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="associatedVehicleFilter"
                                       :list="associatedVehicleOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

              </b-row>
            </b-container>
          </b-collapse>
        </b-container>

        <b-container slot="row-after-per-page" class="mw-100 p-0">
          <b-row>
            <b-col>
              <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0"
                        id="excel-button" @click="$refs.notTransmittingObuTable.excel($tc('message.obu', 2))"> Excel
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </standard-table>
    </b-card>

  </b-container>
</template>

<script>
import { cloneDeep, find, isNil, filter } from 'lodash'
import { DateTime } from 'luxon'
import { Italian } from 'flatpickr/dist/l10n/it'
import Vue from 'vue'

export default {
  name: 'NotTransmittingObu',
  mounted () {
    this.$root.$on('change-lang', () => {
      if (this.$el.isConnected) {
        this.getStaticOptions()
      }
    })
  },
  data () {
    const genericDateOptions = {
      dateFormat: 'Y-m-d',
      mode: 'single',
      altFormat: 'D j M Y',
      altInput: true,
      locale: Italian,
      minDate: '',
      maxDate: DateTime.local().toSQLDate(),
      disable: []
    }
    const config = this.$route.meta.config
    const today = DateTime.local().toSQLDate()
    return {
      config,
      today,
      DateTime,
      genericDateOptions,
      start: null,
      items: [],
      originalItems: [],
      fields: [],
      showCollapse: true,
      startDateConfig: cloneDeep(genericDateOptions),
      lastPositionItems: [],
      assignedTrackers: [],
      allVehicles: [],
      timeFilter: null,
      timeOptions: [
        { text: this.$tc('message.selectOption'), value: -1 },
        { text: this.$tc('message.oneWeek'), value: 7 },
        { text: this.$tc('message.oneMonth'), value: 30 },
        { text: this.$tc('message.threeMonths'), value: 90 },
        { text: this.$tc('message.customize'), value: 0 }
      ],
      showPersonalizedDate: false,
      personalizedDate: null,
      associatedVehicleOptions: [
        { text: this.$tc('message.all'), value: 0 },
        { text: this.$tc('message.yes'), value: true },
        { text: this.$tc('message.no'), value: false }
      ],
      associatedVehicleFilter: 0,
      emptyString: '-----------------',
      emptyDate: '0000000000',
      associatedDateFilter: 0,
      showTimeFilter: true,
    }
  },
  created () {
    this.getOptions().then(() => {
      this.fetchData()
    })
  },
  watch: {
    personalizedDate (val) {
      if (val !== null) {
        this.start = val
        this.items = filter(this.originalItems, (item) => item.date < DateTime.fromSQL(this.start).toMillis() / 1000 || item.date === this.emptyDate)
      }

      if (this.associatedDateFilter === false) {
        this.showTimeFilter = false
        this.timeFilter = -1
        this.items = filter(this.items, (item) => item.date === this.emptyDate)
      } else if (this.associatedDateFilter === true) {
        this.showTimeFilter = true
        this.items = filter(this.items, (item) => item.date !== this.emptyDate)
      }

      if (this.associatedVehicleFilter === false) {
        this.items = filter(this.items, (item) => item.plateNumber === this.emptyString)
      } else if (val === true) {
        this.items = filter(this.items, (item) => item.plateNumber !== this.emptyString)
      }
    },
    timeFilter (val) {
      if (val === 0) {
        this.showPersonalizedDate = true
      } else {
        this.showPersonalizedDate = false
        this.personalizedDate = null
        if (val === -1) {
          this.items = this.originalItems
        } else if (val !== null) {
          this.start = new DateTime(this.today).plus({ days: -val }).toSQLDate()
          this.items = filter(this.originalItems, (item) => item.date < DateTime.fromSQL(this.start).toMillis() / 1000 || item.date === this.emptyDate)
        }
      }
      if (this.associatedDateFilter === false) {
        this.items = filter(this.items, (item) => item.date === this.emptyDate)
      } else if (this.associatedDateFilter === true) {
        this.items = filter(this.items, (item) => item.date !== this.emptyDate)
      }

      if (this.associatedVehicleFilter === false) {
        this.items = filter(this.items, (item) => item.plateNumber === this.emptyString)
      } else if (val === true) {
        this.items = filter(this.items, (item) => item.plateNumber !== this.emptyString)
      }
    },
    associatedVehicleFilter (val) {
      if (val === false) {
        this.items = filter(this.originalItems, (item) => item.plateNumber === this.emptyString)
      } else if (val === true) {
        this.items = filter(this.originalItems, (item) => item.plateNumber !== this.emptyString)
      } else {
        this.items = this.originalItems
      }
      if (this.associatedDateFilter === false) {
        this.items = filter(this.items, (item) => item.date === this.emptyDate)
      } else if (this.associatedDateFilter === true) {
        this.items = filter(this.items, (item) => item.date !== this.emptyDate)
      }
      if (this.timeFilter !== null) {
        this.start = new DateTime(this.today).plus({ days: -this.timeFilter }).toSQLDate()
        this.items = filter(this.items, (item) => item.date < DateTime.fromSQL(this.start).toMillis() / 1000 || item.date === this.emptyDate)
      }
    },
    associatedDateFilter (val) {
      if (val === false) {
        this.showTimeFilter = false
        this.timeFilter = -1
        this.items = filter(this.originalItems, (item) => item.date === this.emptyDate)
      } else if (val === true) {
        this.showTimeFilter = true
        this.items = filter(this.originalItems, (item) => item.date !== this.emptyDate)
      } else {
        this.showTimeFilter = true
        this.items = this.originalItems
      }
      if (this.associatedVehicleFilter === false) {
        this.items = filter(this.items, (item) => item.plateNumber === this.emptyString)
      } else if (val === true) {
        this.items = filter(this.items, (item) => item.plateNumber !== this.emptyString)
      }
      if (this.timeFilter !== null) {
        this.showPersonalizedDate = false
        this.start = new DateTime(this.today).plus({ days: -this.timeFilter }).toSQLDate()
        this.items = filter(this.items, (item) => item.date < DateTime.fromSQL(this.start).toMillis() / 1000 || item.date === this.emptyDate)
      }
    }
  },
  methods: {
    getOptions () {
      const axiosArray = []
      this.getStaticOptions()
      axiosArray.push(this.getVehicles())
      axiosArray.push(this.getItems())
      return Vue.myAll(axiosArray).then(r => r)
    },
    async fetchData () {
      this.$root.$emit('activeLoader', true)
      if (this.originalItems.length === 0) {
        this.assignedTrackers.forEach((tracker) => {
          var founded = find(this.lastPositionItems, item => item.obu === tracker.serialNumber)
          if (isNil(founded)) {
            const foundedVehicle = find(this.allVehicles, vehicle => vehicle.imei !== '' && !!vehicle.imei && !!tracker.imei && tracker.imei === vehicle.imei)
            this.items.push({
              obu: tracker.serialNumber,
              date: this.emptyDate,
              plateNumber: !isNil(foundedVehicle) ? foundedVehicle.plateNumber : this.emptyString
            })
          }
        })
        this.lastPositionItems.forEach((position) => {
          const foundedVehicle = find(this.allVehicles, obj => obj.id === position.properties.vehicleId)
          const foundedSerialNumber = find(this.assignedTrackers, obj => obj.imei === position.properties.imei)
          this.items.push({
            obu: foundedSerialNumber.serialNumber,
            date: position.properties.ts,
            plateNumber: !isNil(foundedVehicle) ? foundedVehicle.plateNumber : this.emptyString
          })
        })
        this.originalItems = this.items
      }
      this.$root.$emit('activeLoader', false)
    },
    getStaticOptions () {
      this.fields = [
        {
          key: 'date',
          sortByFormatted: false,
          formatter: (value, key, item) => {
            if (item.date !== this.emptyDate) {
              var newDate = new Date()
              newDate.setTime(item.date * 1000)
              return newDate.toLocaleDateString()
            }
            return this.emptyString
          },
          label: this.$t('message.lastTransmissionDate'),
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'obu',
          label: this.$tc('message.obu', 1),
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'plateNumber',
          label: this.$tc('message.numberPlate', 1),
          sortable: true,
          sortDirection: 'desc'
        }]
    },
    getLastPositions () {
      return Vue.myGet(this, '/positions/trackers/last', 'positions').then((positions) => {
        positions.forEach((position) => {
          var thisTracker = find(this.assignedTrackers, tracker => tracker.imei === position.properties.imei)
          if (!isNil(thisTracker)) {
            this.lastPositionItems.push(position)
          }
          this.lastPositionItems.sort(function (a, b) { return b.properties.ts - a.properties.ts })
        })
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getItems () {
      return Vue.myGet(this, '/trackers?assigned=true', 'trackers').then((trackersAssigned) => {
        this.assignedTrackers = trackersAssigned
        this.getLastPositions()
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    resetFilters () {
      this.timeFilter = null
      this.showPersonalizedDate = false
      this.showTimeFilter = true
      this.associatedVehicleFilter = 0
      this.associatedDateFilter = 0
    //  this.personalizedDate = null
    },
    getVehicles () {
      return Vue.myGet(this, '/vehicles?all=true', 'vehicles').then((vehicles) => {
        this.allVehicles = vehicles
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    }
  }
}
</script>

<style scoped>

</style>
